const PictViewClass = require('pict-view');

class LIMSDocumentRecordCreate extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {import('../LIMS-Application-Web').LIMSPict} */
		this.pict;

		this.AppData.DocumentDetails = {};
		this.ActiveDocumentLogs = [];
		this.LIMSDocumentRecordBackTo = null;
		this.manifest = require('./defaultDocumentCreateManifest.json');
	}

	async onBeforeRenderAsync(pCallback, pRenderable)
	{
		this.AppData.DocumentDetails = {};
		const session = await this.pict.providers.SessionProvider.getSession();
		this.pict.PictApplication.changeTheme('Create');
		if (!this.initialized || (session.CustomerID !== this.customer))
		{
			this.customer = session.CustomerID;
			// Check for a manifest from the DB before loading the default.
			const remoteManifest = await this.pict.ManifestPackagingService.loadRecordManifestSchema('Document', 'Create', this.pict.PictApplication.options.pict_configuration.Product);
			this.manifest = remoteManifest || this.manifest;
			this.pict.views.PictFormMetacontroller.clearManifestDescription();
			this.pict.views.PictFormMetacontroller.bootstrapPictFormViewsFromManifest(this.manifest);
			this.pict.views['PictSectionForm-DocumentCreate'].viewMarshalDestination = 'AppData';
			this.pict.views['PictSectionForm-DocumentCreate'].options.DefaultDestinationAddress = '#LIMSDocumentRecordCreate-View-Container';
			// @ts-ignore
			for (const pickList of this.manifest.PickLists || [])
			{
				this.pict.providers.DynamicMetaLists.rebuildListByHash(pickList.Hash);
			}
			this.pict.views['PictSectionForm-DocumentCreate'].rebuildCustomTemplate();
			this.initialized = true;
		}
		super.onBeforeRenderAsync(async () =>
		{
			try
			{
				this.pict.views['PictSectionForm-DocumentCreate'].rebuildCustomTemplate();
				this.log.info('Document Details view rendered with Active Record', this.AppData.DocumentDetails);
			}
			catch (error)
			{
				this.log.error('Error in Document Details onBeforeRenderAsync:', error);
			}
			return pCallback();
		}, pRenderable);
	}

	async clearDocument(pRender = true)
	{
		this.AppData.DocumentDetails = {};
		if (pRender)
		{
			await new Promise((resolve) => this.renderAsync(() =>
			{
				this.log.info('Document Create view cleared');
				resolve();
			}));
		}
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {object} pDocumentRecord - The Document record to view
	 * @param {string} pOpenTab - The tab to open when the Document detail view is shown
	 * @return {Promise<void>}
	 * @async
	 */
	async showDocumentDetailView(pIDDocument, pDocumentRecord, pOpenTab = 'Details')
	{
		// if a Document record is passed in, use it, otherwise get the Document record by ID
		if (pDocumentRecord)
		{
			this.AppData.DocumentDetails = Array.isArray(pDocumentRecord) ? pDocumentRecord[0] : pDocumentRecord;
		}
		else
		{
			const tmpRecord = await this.pict.providers.DocumentProvider.getDocumentByID(pIDDocument);
			this.AppData.DocumentDetails = tmpRecord;
		}
		// render the Document detail view
		await new Promise((resolve, reject)=>
		{
			this.renderAsync(() =>
			{
				this.log.info('Document Details View Rendered with Active Record', this.AppData.DocumentDetails);
				resolve();
			});
		});
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').ErrorCallback} fCallback
	 * @param {import('pict-view').Renderable} pRenderable
	 */
	onAfterRenderAsync(fCallback, pRenderable)
	{
		this.pict.views['PictSectionForm-DocumentCreate'].render();
		this.pict.views['PictSectionForm-DocumentCreate'].marshalToView();

		return super.onAfterRenderAsync(fCallback, pRenderable);
	}

	toggleTabContent(event, pTabID)
	{
		// clear the active class from all tabs
		const tmpTabs = document.querySelectorAll('.tabs ul li');
		tmpTabs.forEach((tab) =>
		{
			tab.classList.remove('is-active');
		});
		// set the active class on the selected tab
		const tmpActiveTab = event.currentTarget;
		if (tmpActiveTab)
		{
			tmpActiveTab?.parentElement.classList.add('is-active');
		}
		// hide all the tab content
		const tmpTabContent = document.querySelectorAll('.tab-content');
		tmpTabContent.forEach((content) =>
		{
			content.classList.remove('is-active');
		});
		// show the selected tab content
		const tmpActiveTabContent = document.getElementById(`${pTabID}-Content`);
		if (tmpActiveTabContent)
		{
			tmpActiveTabContent.classList.add('is-active');
		}
	}

	async createNewDocument(event)
	{
		// prevent the form refeshing the page
		if (event)
		{
			event.preventDefault();
			event.stopPropagation();
		}

		event.currentTarget.classList.add('is-loading');
		this.log.info('Creating new Document...');
		this.log.info(JSON.stringify(this.AppData.DocumentDetails));

		const tmpDocument = this.AppData.DocumentDetails;

		// save the Document
		try
		{
			delete tmpDocument.CreatingIDUser;
			const tmpResult = await new Promise((resolve, reject) =>
			{
				this.pict.HeadlightRestClient.upsertEntity('Document', tmpDocument, (pError, pResult) =>
				{
					if (pError)
					{
						reject(pError);
					}
					resolve(pResult);
				});
			});
			this.AppData.DocumentDetails = tmpResult;
			this.log.info('Document created, going to the Details view...');
			this.goToReadView();
		}
		catch (error)
		{
			this.log.error('Error creating Document', error);
			this.pict.views.HeadlightPanels.toast({ message: `Error creating Document: ${error.message || error}`, type: 'is-danger' });
		}
	}

	goToReadView(pEvent)
	{
		if (pEvent)
		{
			pEvent.preventDefault();
			pEvent.stopPropagation();
		}
		if (!this.AppData.DocumentDetails)
		{
			this.log.error('No active Document to view');
			return;
		}
		this.log.info('Going to Read Document view for Document GUID:', this.AppData.DocumentDetails.GUIDDocument);
		this.pict.providers.LIMSRouter.router.navigate(`/Document/${ this.AppData.DocumentDetails.GUIDDocument }`);
	}

	handleFormSubmitAction(event)
	{
		event.preventDefault();
		event.stopPropagation();
		this.log.info('Document form submitted');

		this.createNewDocument(event);
	}
}

module.exports = LIMSDocumentRecordCreate;

module.exports.default_configuration =
{
	ViewIdentifier: 'LIMSDocumentRecordCreate',
	DefaultRenderable: 'LIMSDocumentRecordCreate',
	DefaultDestinationAddress: '#LIMS-Application-Container',
	CSS: /*css*/`
		.tab-content {
			display: none;
		}
		.tab-content.is-active {
			display: block;
		}`,
	Templates:
	[
		{
			Hash: 'LIMSDocumentRecordCreate-Wrapper',
			Template: /*html*/`
			<form class="container form" data-document-id="{~D:Record.IDDocument~}" onsubmit="_Pict.views.LIMSDocumentRecordCreate.handleFormSubmitAction(event);">
				{~T:LIMSDocumentRecordCreate-DocumentHeader:AppData.DocumentDetails~}
				<!-- LIMSDocumentRecord Content > Tab Details View -->
				<div id="LIMSDocumentRecordCreatePanel-Details-Content" class="tab-content is-active">
					<div id="LIMSDocumentRecordCreate-Details-Container">{~T:LIMSDocumentRecordCreate-Tab-Details:AppData.DocumentDetails~}</div>
				</div>
			</form>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DocumentHeader',
			Template: /*html*/`
			<header id="PRSP_Title_Container" class="p-5 pb-0 has-background-text-soft is-vcentered">
				<h2 class="title is-size-4" id="PRSP_Title">Create New Document</h2>
			</header>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-Tab-Details',
			Template: /*html*/`
			<!-- Placeholder for dynamic section -->
			<div id="LIMSDocumentRecordCreate-View-Container" class="app-page-gutters-for-mobile px-5 mt-2"></div>
			{~T:LIMSDocumentRecordCreate-Tab-Details-Buttons-Create:AppData.DocumentDetails~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-Tab-Details-Buttons-Create',
			Template: /*html*/`
			<div class="columns px-3 m-0">
				<div class="column px-3 py-1 has-text-right">
					<button type="button" class="button is-link is-soft" title="Clear Document" onclick="_Pict.views.LIMSDocumentRecordCreate.clearDocument(true)">
						<span class="icon">
							<i class="fa fa-fw fa-refresh"></i>
						</span>
						<span class="icon-text">Clear</span>
					</button>
					<button type="submit" class="button is-link" title="Create new Document">
						<span class="icon">
							<i class="fa fa-fw fa-save"></i>
						</span>
						<span class="icon-text">Save New Document</span>
					</button>
				</div>
			</div>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-EntityValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-NA',
			Template: /*html*/`<span class="has-text-text-50">N/A</span>`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Name',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Name-Empty',
			Template: /*html*/`Unnamed Document #{~D:Record.IDDocument~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-Description',
			Template: /*html*/`{~D:Record.Description~}`,
		},
		{
			Hash: 'LIMSDocumentRecordCreate-DatumValue-ParentDocument',
			Template: /*html*/`{~D:Record.ParentDocument.Name~}`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'LIMSDocumentRecordCreate',
			TemplateHash: 'LIMSDocumentRecordCreate-Wrapper',
			DestinationAddress: '#LIMS-Application-Container',
			RenderType: 'replace',
		},
	],
};
